import { ReactNode } from 'react';

import styles from './styles.module.scss';

type TabListProps = {
  children: ReactNode;
};

export const TabList = ({ children }: TabListProps) => {
  return (
    <div className={styles.tabList} role="tablist">
      {children}
    </div>
  );
};
